import { InvoiceTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1971. 請求タスクMF請求書連携
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/create_mf_billing
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const createMoneyForwardBilling = (props: Props): Promise<InvoiceTaskComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/create_mf_billing`,
    props
  );
};

export const useCreateMoneyForwardBilling = () => {
  return useMutation({
    mutationFn: createMoneyForwardBilling,
  });
};
